import { SnackbarManager } from '@cmg/design-system';
import { saveAs } from 'file-saver';
import React from 'react';

import { rolodexApiClient } from '../../../../../../../common/api/rolodexApiClient';

export function useDownloadCertificate(cmgEntityKey: string) {
  const [loading, setLoading] = React.useState(false);

  const handleDownloadCertificate = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await rolodexApiClient.attestationForm_DownloadCertificatePdf(
        cmgEntityKey,
        undefined
      );
      saveAs(response.data, '5130/31-Certificate.pdf');
      SnackbarManager.success('Download successfully completed.');
    } catch {
      SnackbarManager.error(
        'An error has occurred while trying to download your data. Please try again later.'
      );
    } finally {
      setLoading(false);
    }
  }, [cmgEntityKey]);

  return { handleDownloadCertificate, loading };
}
